import React from 'react';
import { View, Image } from 'react-native-web';

class ImageBlockInput extends React.Component {
	
	state = {
		base64ToRender: '',
	};

	componentDidMount = () => {
		const { getEntityData } = this.props.blockProps;
		const base64ToRender = getEntityData().base64;

		this.setState({ base64ToRender: base64ToRender });
	};

	render() {
		return (
			<View style={{ width: 256, height: 128, justifyContent: 'center' }}>
				{
					this.state.base64ToRender !== '' &&
					<Image
						source={{ uri: `data:image/jpeg;base64,${this.state.base64ToRender}` }}
						style={{ width: 256, height: 128 }}
						resizeMode='contain'
					/>
				}
			</View>
		)
	}
}

export { ImageBlockInput };